export const cloudFunctionEndpoint = `/.netlify/functions/recaptcha`
export const siteKey = `6LdwFoQqAAAAAGqrGHkS3MDBx7rtLYy8cqeG9c5Y`

export const formAction = subdomain =>
  `https://${subdomain}.activehosted.com/proc.php`
